import { Routes, Route } from 'react-router-dom'
import Home from '../pages/Home'
import WebApps from '../pages/WebApps'
import Contact from '../pages/Contact'


const AppRoutes = () => {
    return (
        <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/hangar' element={<WebApps />} />
            <Route path='/contact' element={<Contact />} />
        </Routes>
    )
}

export default AppRoutes